interface actionWithSpinnerLoadingType {
  handleAction: () => void;
  setIsLoading: (loading: boolean) => void;
  duration?: number;
  handleFocus?: () => void;
}

const DEFAULT_ACTION_TIME_DURATION: number = 800;

export function actionWithSpinnerLoading({
  handleAction,
  setIsLoading,
  duration = DEFAULT_ACTION_TIME_DURATION,
  handleFocus,
}: actionWithSpinnerLoadingType) {
  setIsLoading(true);
  setTimeout(() => {
    setIsLoading(false);
    handleAction();
    if (handleFocus) handleFocus();
  }, duration);
}
